import { categoryStore } from '@/store';
import { storyStore } from '@story/mixins/storyStore';
import { partnersMixin } from './partners';
import { sidebarMixin } from './sidebar';

export const faqMixin = {
    data() {
        return {
            article: null,
            categoryState: categoryStore.state,
            storyState: storyStore.state,
            loaded: false,
            title: null,
        };
    },
    mixins: [sidebarMixin, partnersMixin],
    mounted() {
        if (!this.storyState.storybookMode) {
            this.getContent();
            if (window.track) {
                window.track.pageview(`/${this.$route.name}`);
            } else {
                this.$ga.page(`/${this.$route.name}`);
            }
        } else {
            this.loaded = true;
        }
    },
    methods: {
        getContent() {
            let routeName = this.$route.name;
            if ('aboutus' === routeName) {
                routeName = 'about';
            }

            const langID =
                this.$globalConstants.host.category_tree_languages.find(
                    (lang) =>
                        lang.iso_code ===
                        this.$globalConstants.host.language_code
                )?.id;

            const languageParam = langID || '';

            axios
                .get(
                    `/host/${this.$globalConstants.host['id']}/hostArticle/${routeName}?language_id=${languageParam}`
                )
                .then((response) => {
                    this.article = response.data.article
                        ? response.data.article
                        : null;
                    this.title = response.data.article
                        ? response.data.article.title
                        : null;
                    this.loaded = true;
                });
        },
    },
    setArticle(article) {
        this.article = article;
    },
};
